var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 7.10005L13.4 5.79595V2.60005C13.4 2.10505 12.995 1.70005 12.5 1.70005H11.6C11.105 1.70005 10.7 2.10505 10.7 2.60005V3.09775L8.9 1.29955C8.6543 1.06735 8.4293 0.800049 8 0.800049C7.5707 0.800049 7.3457 1.06735 7.1 1.29955L1.295 7.10005C1.0142 7.39255 0.800003 7.60585 0.800003 8.00005C0.800003 8.50675 1.1888 8.90005 1.7 8.90005H2.6V14.3C2.6 14.795 3.005 15.2 3.5 15.2H6.2V10.7C6.2 10.205 6.605 9.80005 7.1 9.80005H8.9C9.395 9.80005 9.8 10.205 9.8 10.7V15.2H12.5C12.995 15.2 13.4 14.795 13.4 14.3V8.90005H14.3C14.8112 8.90005 15.2 8.50675 15.2 8.00005C15.2 7.60585 14.9858 7.39255 14.705 7.10005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9abd18f1dc0114781d9fd2cae40f8914.svg";
export { ForwardRef as ReactComponent };